// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useCallback, useContext } from 'react'
import { AuthContext } from 'components/Auth'
import { UserInfoWrapper } from './styles'

import {
  Authenticator,
  Greetings,
} from 'aws-amplify-react'

const UserInfo = () => {
  const {
    updateAuthState,
    user,
  } = useContext(AuthContext)

  // only trigger updateAuthState if this change type is 'signIn'
  // this is to control flow on updating AuthContext.
  // This component's <Authenticator /> will call this.handleStateChange
  // with various changes, but for this element, all we care about
  // is capturing the 'signIn' event and triggering the AuthContext
  // to update itself accordingly.
  const handleStateChange = useCallback(changeType => (
    changeType === 'signIn' &&
    updateAuthState()
  ), [])

  return (
    <UserInfoWrapper>
      {
        user
          ? (
            <Authenticator
              hideDefault={true}
              onStateChange={handleStateChange}>
              <Greetings />
            </Authenticator>
          ) : (
            <strong>{'Please Sign In'}</strong>
          )
      }
    </UserInfoWrapper>
  )
}

export default UserInfo
